import { FaSearch } from "react-icons/fa";

interface lupaProps {
  acao: () => void;
  setTooltipLeft?: (left: number) => void;
  setTooltipTop?: (top: number) => void;
  setTooltipConteudo?: (conteudo: string | JSX.Element) => void;
  setTooltipWidth?: (width: number) => void;
  setShowTooltip?: (show: boolean) => void;
  mensagemTooltip?: NullableString;
  color?: string;
}
export function Lupa({
  acao,
  setTooltipLeft = () => {},
  setTooltipTop = () => {},
  setTooltipConteudo = () => {},
  setTooltipWidth = () => {},
  setShowTooltip = () => {},
  mensagemTooltip = null,
  color = "#000000",
}: lupaProps) {
  if (!mensagemTooltip) {
    return <FaSearch style={{ cursor: "pointer" }} onClick={acao} />;
  }

  return (
    <span
      onMouseEnter={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        const { left, top } = event.currentTarget.getBoundingClientRect();
        setTooltipLeft(left);
        setTooltipTop(top);
        setTooltipConteudo(mensagemTooltip);
        setTooltipWidth(95);
        setShowTooltip(true);
      }}
      onMouseLeave={() => {
        setShowTooltip(false);
        setTooltipLeft(0);
        setTooltipTop(0);
        setTooltipConteudo("");
      }}
    >
      <FaSearch style={{ cursor: "pointer", color }} onClick={acao} />
    </span>
  );
}
